<template>
    <div class="ch-container">
        <vx-card class="mb-4" :title="questionsBank.title">
          <div slot="no-body-bottom" class="flex justify-between text-center mt-4">
            <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
              <p class="mt-4">مجموع الأسئلة</p>
              <p class="mb-4 text-3xl font-semibold">{{questions.length}}</p>
            </div>
            <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
              <p class="mt-4">مجموع الدرجات</p>
              <p class="mb-4 text-3xl font-semibold">{{totalMarks}}</p></div>
          </div>
        </vx-card>
        <question-item v-for="question in questions" :key="question.id" :data="question"/>
    </div>
</template>

<script>
  import questionsBanksAPI from '@/api/questionsBanksAPI'
  import QuestionItem from '@/views/questionBanks/QuestionItem'

  export default {
      name: 'QuestionBank',
      components: { QuestionItem },
      data () {
          return {
              questionsBank: {},
              questions: []
          }
      },
      computed: {
          totalMarks() {
              return this.questions.reduce((total, questions) => total + parseInt(questions.mark), 0)
          },
      },
      beforeRouteEnter(to,from,next){
          questionsBanksAPI.setCourseId(to.params.course_id)
          questionsBanksAPI.getById(to.params.question_bank_id)
              .then(({data}) => {
                  next(vm => {
                      vm.questions = data.questions
                      vm.questionsBank = data.questionsBank
                  })
              })
      }
  }
</script>
